import { render, staticRenderFns } from "./PopupMSDSSearch.vue?vue&type=template&id=32babd92&scoped=true"
import script from "./PopupMSDSSearch.vue?vue&type=script&lang=js"
export * from "./PopupMSDSSearch.vue?vue&type=script&lang=js"
import style0 from "./PopupMSDSSearch.vue?vue&type=style&index=0&id=32babd92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32babd92",
  null
  
)

export default component.exports